/*
  aBeauty menu enhancements (progressive enhancement peste <details> Dawn).

  - Hover-intent pe desktop cu SAFE TRIANGLE (problema mișcării diagonale).
  - Escape închide meniul deschis, de oriunde, și readuce focusul pe summary (cerință W3C APG).
  - Click în afara meniului îl închide (<details> nativ NU face asta).
  Fără JS, meniul rămâne funcțional pe click (native <details>).

  DE CE SAFE TRIANGLE: panoul mega e full-width, sub TOATE top-level-urile. Drumul diagonal de la
  „Tratamente" spre coloanele din dreapta sau spre rail trece pe deasupra lui „Prețuri", „Clinici" etc.
  Cu hover simplu, acele triggere deschid alt panou sub cursor, în drum. Cât timp pointerul se mișcă
  în interiorul triunghiului dintre poziția lui de acum ~120ms și colțurile de sus ale panoului deschis,
  îl considerăm „în drum spre panou" și ignorăm hover-ul pe celelalte triggere.
  Baymard documentează empiric problema; NN/g o endorsează normativ ca mitigare („the dropdown should
  remain visible" când pointerul e pe traiectorie).

  TIMING: OPEN 200ms. NN/g și Baymard prescriu 300-500ms de cursor OPRIT, dar cifrele lor presupun un
  timer simplu, fără triunghi; Friedman (Smashing) critică pe fond lag-ul pe fiecare interacțiune.
  Cu triunghiul care poartă sarcina traiectoriei, 200ms taie deschiderile accidentale la trecere fără
  să pară leneș. CLOSE 220ms e defensabil din același motiv.
*/
(function () {
  'use strict';

  var OPEN_DELAY = 200;
  var CLOSE_DELAY = 220;
  var SAMPLE_MS = 120; // cât de „vechi" e vârful triunghiului
  var hoverCapable = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');

  var openDetails = null;
  var pointer = { x: 0, y: 0 };
  var anchor = { x: 0, y: 0 }; // poziția pointerului acum ~SAMPLE_MS
  var sampleTimer = null;

  function summaryOf(details) {
    return details ? details.querySelector('summary') : null;
  }

  function panelOf(details) {
    return details ? details.querySelector('.mega-menu__content') : null;
  }

  function closeDetails(details) {
    if (!details || !details.open) return;
    details.removeAttribute('open');
    var s = summaryOf(details);
    if (s) s.setAttribute('aria-expanded', 'false');
    if (openDetails === details) openDetails = null;
  }

  function closeOthers(except) {
    document.querySelectorAll('.header__inline-menu details.mega-menu[open]').forEach(function (other) {
      if (other !== except) closeDetails(other);
    });
  }

  function openDetailsEl(details) {
    if (!details || details.open) return;
    closeOthers(details);
    details.setAttribute('open', '');
    var s = summaryOf(details);
    if (s) s.setAttribute('aria-expanded', 'true');
    openDetails = details;
  }

  // --- geometrie safe triangle ---
  function sign(p1, p2, p3) {
    return (p1.x - p3.x) * (p2.y - p3.y) - (p2.x - p3.x) * (p1.y - p3.y);
  }

  function pointInTriangle(p, a, b, c) {
    var d1 = sign(p, a, b);
    var d2 = sign(p, b, c);
    var d3 = sign(p, c, a);
    var hasNeg = d1 < 0 || d2 < 0 || d3 < 0;
    var hasPos = d1 > 0 || d2 > 0 || d3 > 0;
    return !(hasNeg && hasPos);
  }

  /*
    True dacă pointerul pare să se îndrepte spre panoul deschis: punctul curent cade în triunghiul
    format de poziția de acum ~SAMPLE_MS și colțurile de sus ale panoului. Panoul fiind full-width,
    triunghiul acoperă mișcările descendente spre el, dar NU o mișcare pur orizontală pe navbar
    (aceea trebuie să schimbe meniul, e intenție reală).
  */
  function movingTowardPanel() {
    if (!openDetails) return false;
    var panel = panelOf(openDetails);
    if (!panel) return false;
    var r = panel.getBoundingClientRect();
    if (r.height === 0) return false;
    // pointerul e deja în panou: triunghiul nu mai are ce decide
    if (pointer.y >= r.top) return false;
    /*
      Cursor practic oprit => anchor coincide cu pointer, triunghiul degenerează într-un punct și
      pointInTriangle ar întoarce `true` pe la toate testele de semn (două semne ies 0). Rezultatul:
      un meniu pe care te oprești deliberat nu s-ar mai deschide niciodată. Oprirea NU e „în drum
      spre panou", e intenție: ieșim pe false.
    */
    var dx = pointer.x - anchor.x;
    var dy = pointer.y - anchor.y;
    if (dx * dx + dy * dy < 25) return false; // sub ~5px de mișcare în ultimele SAMPLE_MS
    return pointInTriangle(
      pointer,
      anchor,
      { x: r.left, y: r.top },
      { x: r.right, y: r.top }
    );
  }

  /*
    Pointerul e deja ÎN panoul deschis. Fără verificarea asta, un trigger peste care am trecut în drum
    (ex. „Prețuri", cu timerul de deschidere pornit) și-ar deschide panoul după OPEN_DELAY, deși cursorul
    a ajuns între timp în panoul lui „Tratamente". `movingTowardPanel` nu prinde cazul, fiindcă iese
    devreme exact când pointerul a intrat în panou.
  */
  function pointerInOpenPanel() {
    if (!openDetails) return false;
    var panel = panelOf(openDetails);
    if (!panel) return false;
    var r = panel.getBoundingClientRect();
    if (r.height === 0) return false;
    return pointer.x >= r.left && pointer.x <= r.right && pointer.y >= r.top && pointer.y <= r.bottom;
  }

  function init() {
    var menus = document.querySelectorAll('.header__inline-menu header-menu');
    if (!menus.length) return;

    document.addEventListener(
      'mousemove',
      function (e) {
        pointer.x = e.clientX;
        pointer.y = e.clientY;
      },
      { passive: true }
    );

    // vârful triunghiului rămâne în urmă cu ~SAMPLE_MS, altfel ar fi degenerat (anchor == pointer)
    sampleTimer = setInterval(function () {
      anchor.x = pointer.x;
      anchor.y = pointer.y;
    }, SAMPLE_MS);

    menus.forEach(function (menu) {
      var details = menu.querySelector('details.mega-menu');
      if (!details) return;
      var openTimer = null;
      var closeTimer = null;

      menu.addEventListener('mouseenter', function () {
        if (!hoverCapable.matches) return;
        clearTimeout(closeTimer);
        clearTimeout(openTimer);
        openTimer = setTimeout(function tryOpen() {
          // cursorul a plecat între timp de pe trigger: renunță (previne și reîncercarea la infinit)
          if (!menu.matches(':hover')) return;
          // în drum spre panoul altui meniu, sau deja ajuns în el: nu fura hover-ul, reîncearcă
          if (openDetails !== details && (movingTowardPanel() || pointerInOpenPanel())) {
            openTimer = setTimeout(tryOpen, SAMPLE_MS);
            return;
          }
          openDetailsEl(details);
        }, OPEN_DELAY);
      });

      menu.addEventListener('mouseleave', function () {
        if (!hoverCapable.matches) return;
        clearTimeout(openTimer);
        clearTimeout(closeTimer);
        closeTimer = setTimeout(function tryClose() {
          if (movingTowardPanel() && openDetails === details) {
            closeTimer = setTimeout(tryClose, SAMPLE_MS);
            return;
          }
          closeDetails(details);
        }, CLOSE_DELAY);
      });

      // sincronizează aria-expanded și starea, inclusiv la click nativ pe summary
      details.addEventListener('toggle', function () {
        var s = summaryOf(details);
        if (s) s.setAttribute('aria-expanded', details.open ? 'true' : 'false');
        if (details.open) {
          closeOthers(details);
          openDetails = details;
        } else if (openDetails === details) {
          openDetails = null;
        }
      });
    });

    // Escape de oriunde: <details> nu are comportament nativ de dismiss.
    // APG: „closes it and sets focus on the button that controls that dropdown".
    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape' && event.key !== 'Esc') return;
      var target = openDetails;
      if (!target) return;
      var s = summaryOf(target);
      closeDetails(target);
      if (s) s.focus();
    });

    // click în afară: <details> rămâne altfel agățat deschis după o deschidere prin click
    document.addEventListener('click', function (event) {
      if (!openDetails) return;
      var menu = openDetails.closest('header-menu');
      if (menu && !menu.contains(event.target)) closeDetails(openDetails);
    });

    // pointerul a plecat din fereastră cu meniul deschis
    document.addEventListener('pointercancel', function () {
      if (openDetails) closeDetails(openDetails);
    });
  }

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();
